import { type JSX, splitProps } from "solid-js";
import { cn } from "~/util/utils";

interface SpacerProps extends JSX.HTMLAttributes<HTMLDivElement> {}

export function Spacer(props: SpacerProps) {
	const [local, other] = splitProps(props, ["class"]);

	return (
		<div
			class={cn("flex-1", local.class)}
			{...other}
		/>
	);
}
